import React from 'react';
import './CardNew.scss';
import './CardNew-media.scss';
import { INewLive } from '../SliderLive/interfaces';
import { GetTypeNews } from '../../services/GlobalFunctions';

import { EnumUrlsPages } from '../../services/Enum';
import { Link } from '../Link/Link';

const CardNew = ({ alias, uri, image, title, date, type, link, linkOut }: INewLive) => {
  const contentCard = (
    <>
      <div className="card-new__gap" />
      {image ? (
        <img src={`${image}`} className="card-new__image" alt="card-new" />
      ) : (
        <div className="card-new__image"></div>
      )}
      <div className="card-new__content">
        <div>
          <p className="card-new__type">{GetTypeNews(type)}</p>
          <h4 className="card-new__title">{title}</h4>
        </div>
        <p className="card-new__date">{date}</p>
      </div>
    </>
  );

  return linkOut ? (
    <a href={link} className="card-new" style={image ? { backgroundColor: 'transparent' } : {}}>
      {contentCard}
    </a>
  ) : (
    <Link
      to={uri ? uri : `${EnumUrlsPages.live}${alias}/`}
      className="card-new"
      style={image ? { backgroundColor: 'transparent' } : {}}
    >
      {contentCard}
    </Link>
  );
};

export default CardNew;
